module.exports = __webpack_public_path__ + "img/IMG_5615-2_FoamcoreMatted.e8963730.jpg";